(function () {
  if (window.__spAccMotion) return;
  window.__spAccMotion = true;

  var SEL = 'details.sp-acc__item, .collapsible-tabs__tab details.disclosure, .product-info-accordion details.disclosure';
  var OPEN_MS = 460, CLOSE_MS = 300;
  var EASE_OUT = 'cubic-bezier(0.22, 1, 0.36, 1)';
  var EASE_STD = 'cubic-bezier(0.4, 0, 0.6, 1)';
  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)');

  function parts(d) {
    var body = d.querySelector(':scope > .sp-acc__body, :scope > .disclosure__panel');
    var content = body && (body.querySelector(':scope > .disclosure__content') || body);
    return { body: body, content: content };
  }

  function stop(d) {
    (d._spAcc || []).forEach(function (a) { a.cancel(); });
    d._spAcc = null;
  }

  function finish(d, body) {
    body.classList.remove('sp-acc-animating');
    d._spAcc = null;
  }

  function open(d, p, from) {
    d._spClosing = false;
    d.classList.remove('is-closing');
    d.open = true;
    p.body.classList.add('sp-acc-animating');
    var to = p.body.scrollHeight;
    var h = p.body.animate([{ height: from + 'px' }, { height: to + 'px' }], { duration: OPEN_MS, easing: EASE_OUT });
    var c = p.content.animate(
      [{ opacity: 0, transform: 'translateY(-6px)' }, { opacity: 1, transform: 'none' }],
      { duration: 380, delay: from > 0 ? 0 : 60, easing: EASE_OUT, fill: 'backwards' });
    d._spAcc = [h, c];
    h.onfinish = function () { finish(d, p.body); };
  }

  function close(d, p, from) {
    d._spClosing = true;
    d.classList.add('is-closing');
    p.body.classList.add('sp-acc-animating');
    var h = p.body.animate([{ height: from + 'px' }, { height: '0px' }], { duration: CLOSE_MS, easing: EASE_STD, fill: 'forwards' });
    var c = p.content.animate([{ opacity: 1 }, { opacity: 0 }], { duration: CLOSE_MS * 0.55, easing: 'ease-out', fill: 'forwards' });
    d._spAcc = [h, c];
    h.onfinish = function () {
      d.open = false;
      d.classList.remove('is-closing');
      d._spClosing = false;
      h.cancel();
      c.cancel();
      finish(d, p.body);
    };
  }

  document.addEventListener('click', function (e) {
    var summary = e.target.closest('summary');
    if (!summary || e.defaultPrevented) return;
    var d = summary.parentElement;
    if (!d || !d.matches(SEL) || (reduce && reduce.matches) || !d.animate) return;
    var p = parts(d);
    if (!p.body) return;
    e.preventDefault();
    var from = d.open ? p.body.getBoundingClientRect().height : 0;
    var opening = !d.open || d._spClosing;
    stop(d);
    if (opening) open(d, p, from);
    else close(d, p, from);
  });
})();
